// start:ng42.barrel
export * from './full.component';
// end:ng42.barrel
